export const MODAL_ACCOUNT_TYPE = 'account.account-type'
export const MODAL_EDIT_STAGES = 'modal-edit-stages'
export const MODAL_EDIT_INVITATION_MESSAGE = 'modal-edit-invitation-message'
export const MODAL_EDIT_EMAIL_SETTINGS = 'modal-edit-email-settings'
export const MODAL_INTERVIEW_SELECT_FOR_EDIT = 'modal-interview-select-for-edit'
export const MODAL_APPLICATION_ALL_INVITED = 'application.all-invited'
export const MODAL_APPLICATION_FORM = 'job-ad-preview.application-form'
export const MODAL_APPLICATION_INVITE_INTERVIEW = 'application.invite'
export const MODAL_APPLICATION_INTRODUCE = 'application.introduce'
export const MODAL_APPLICATION_STAGE = 'application.stage'
export const MODAL_APPLICATION_MESSAGE = 'application.message'
export const MODAL_APPLICATION_MESSAGE_EMAIL = 'application.message.email'
export const MODAL_APPLICATION_MESSAGE_FAVORITE = 'application.message.favorite'
export const MODAL_APPLICATION_MESSAGE_FAVORITE_EDIT = 'application.message.favorite-edit'
export const MODAL_APPLICATION_MESSAGE_VIDEO = 'application.message.video'
export const MODAL_APPLICATION_MESSAGE_SMS = 'application.message.sms'
export const MODAL_APPLICATION_RE_INVITE = 'application.re-invite'
export const MODAL_OTHER_APPLICATIONS = applicationId => `application.${applicationId}.other-applications`
export const MODAL_ATS_TEASER = 'ats-teaser'
export const MODAL_CANDIDATE_INVITE_INTERVIEW = 'candidate.invite'
export const MODAL_CANDIDATE_MESSAGE = 'candidate.message'
export const MODAL_CANDIDATE_MESSAGE_FAVORITE = 'candidate.message.favorite'
export const MODAL_CANDIDATE_MESSAGE_FAVORITE_EDIT = 'candidate.message.favorite-edit'
export const MODAL_CANDIDATE_MESSAGE_EMAIL = 'candidate.message.email'
export const MODAL_CANDIDATE_MESSAGE_VIDEO = 'candidate.message.video'
export const MODAL_CANDIDATE_MESSAGE_SMS = 'candidate.message.sms'
export const MODAL_CANDIDATE_STAGE = 'candidate.stage'
export const MODAL_FEEDBACK_PULSE_TEASER = 'feedback-pulse-teaser'
export const MODAL_HIDE_POSITIONS_FROM_USER = 'modal-hide-positions-from-user'
export const MODAL_REMOVE_USER_FROM_ORGANISATION = 'modal-remove-user-from-organisation'
export const MODAL_INTERVIEW_PUBLISH = 'interview.publish'
export const MODAL_INTERVIEW_INVITE = 'interview.invite'
export const MODAL_INTRODUCE = 'modal-introduce'
export const MODAL_INTRODUCE_LINK = 'modal-introduce-link'
export const MODAL_INTRODUCE_SELECT = 'modal-introduce-select'
export const MODAL_INTERVIEW_ADD = 'modal-interview-add'
export const MODAL_INTERVIEW_STATUS_FORM = 'interview.status-form'
export const MODAL_INTERVIEW_TEASER = 'video-interview-teaser'
export const MODAL_JOB_AD_STATUS_FORM = 'job-ad.status-form'
export const MODAL_JOB_AD_TEAM_FORM = 'job-ad.team-form'
export const MODAL_JOB_AD_PREVIEW = 'job-ad.preview'
export const MODAL_JOB_POSITION_COPY = 'job-position.copy'
export const MODAL_JOB_POSITION_TEAM_FORM = 'job-position.team-form'
export const MODAL_LINK_SHARE = 'link-share'
export const MODAL_QR_SHARE = 'qr-share'
export const MODAL_VIDEO_CHOOSE_METHOD = 'videos.video-choose-method'
export const MODAL_VIDEO_ADD = 'videos.video-add'
export const MODAL_VIDEO_UPLOAD = 'videos.video-upload'
export const MODAL_VIDEO_EDIT = 'videos.video-edit'
export const MODAL_USERS_ADD = 'users.add'
export const MODAL_COMPANY_DEFAULT_PERMISSIONS_EDIT = 'company.default-permissions.edit'
export const MODAL_EDIT_INTRODUCE_BATCHES = 'interview.introduce-batches.edit'
export const MODAL_CRONOFY_LINK_CALENDAR = 'cronofy.link-calendar'
export const MODAL_CRONOFY_PERSONAL_INTERVIEW = 'cronofy.personal-interview'
export const MODAL_CRONOFY_PERSONAL_INTERVIEW_MESSAGE = 'cronofy.personal-interview.message'
